export const launchSchema = {
	title: 'launch schema',
	version: 1,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 70,
		},
		wasLaunched: {
			type: 'boolean',
		},
	},
	required: ['id'],
};
